import { useState, useEffect } from 'react';

export default function Navbar() {
  const [isScrolled, setIsScrolled] = useState(false);
  const [mobileOpen, setMobileOpen] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 50);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const scrollToSection = (id: string) => {
    setMobileOpen(false);
    const element = document.getElementById(id);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <nav
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
        isScrolled ? 'bg-white/95 backdrop-blur-md shadow-lg' : 'bg-white/80 backdrop-blur-sm shadow-sm'
      }`}
    >
      <div className="max-w-7xl mx-auto px-4 sm:px-6 py-2 sm:py-3">
        <div className="flex items-center justify-between">
          <div className="flex flex-col items-start cursor-pointer" onClick={() => scrollToSection('inicio')}>
            <img 
              src="https://public.readdy.ai/ai/img_res/efe3cf72-7a15-40d9-ab18-dc5801d3c329.png" 
              alt="F&A DIGITAL - Evaluación OMR" 
              className="h-14 sm:h-16 lg:h-20 w-auto object-contain drop-shadow-md"
              style={{ imageRendering: 'crisp-edges' }}
            />
          </div>

          <div className="hidden lg:flex items-center space-x-8">
            {[
              { label: 'Nosotros', id: 'about' },
              { label: 'Servicios', id: 'services' },
              { label: 'Proceso', id: 'process' },
              { label: 'Ventajas', id: 'advantages' },
              { label: 'Galería', id: 'gallery' },
              { label: 'FAQ', id: 'faq' },
            ].map((item) => (
              <button
                key={item.id}
                onClick={() => scrollToSection(item.id)}
                className="text-sm font-medium transition-colors whitespace-nowrap cursor-pointer text-gray-700 hover:text-[#0D9488]"
              >
                {item.label}
              </button>
            ))}
            <button
              onClick={() => scrollToSection('contacto')}
              className="bg-gradient-to-r from-[#F59E0B] to-[#D97706] text-white px-6 py-2.5 rounded-full text-sm font-semibold hover:shadow-lg hover:shadow-[#F59E0B]/30 transition-all whitespace-nowrap cursor-pointer"
            >
              Contacto
            </button>
          </div>

          <button className="lg:hidden cursor-pointer" onClick={() => setMobileOpen(!mobileOpen)}>
            <i className={`${mobileOpen ? 'ri-close-line' : 'ri-menu-line'} text-2xl text-[#1A1A2E]`}></i>
          </button>
        </div>
      </div>

      {mobileOpen && (
        <div className="lg:hidden bg-white/98 backdrop-blur-md shadow-xl border-t border-gray-100">
          <div className="px-4 py-5 space-y-1">
            {[
              { label: 'Nosotros', id: 'about', icon: 'ri-team-line' },
              { label: 'Servicios', id: 'services', icon: 'ri-service-line' },
              { label: 'Proceso', id: 'process', icon: 'ri-flow-chart' },
              { label: 'Ventajas', id: 'advantages', icon: 'ri-star-line' },
              { label: 'Galería', id: 'gallery', icon: 'ri-gallery-line' },
              { label: 'FAQ', id: 'faq', icon: 'ri-question-line' },
            ].map((item) => (
              <button
                key={item.id}
                onClick={() => scrollToSection(item.id)}
                className="flex items-center gap-3 w-full text-left text-gray-700 hover:text-[#0D9488] hover:bg-[#0D9488]/5 py-3 px-4 rounded-lg text-sm font-medium cursor-pointer transition-all"
              >
                <i className={`${item.icon} text-lg text-[#0D9488]`}></i>
                {item.label}
              </button>
            ))}
            <button
              onClick={() => scrollToSection('contacto')}
              className="flex items-center justify-center gap-2 w-full bg-gradient-to-r from-[#F59E0B] to-[#D97706] text-white py-3 px-4 rounded-lg text-sm font-semibold cursor-pointer mt-3 hover:shadow-lg transition-all"
            >
              <i className="ri-message-3-line text-lg"></i>
              Contacto
            </button>
          </div>
        </div>
      )}
    </nav>
  );
}